import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import ActionIcon from '../../../components/custom/ActionIcon';
import BackButton from '../../../components/custom/BackButton';
import useUnit from '../../../customHooks/useUnit';


interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedEnv: string;
    updateUnitEnvironment: () => Promise<void>;
}

export default function ModalConfirmUnitEnvironment ({
    modal,
    setModal,
    selectedEnv,
    updateUnitEnvironment
}: Props) {

    const unit = useUnit();
    const toggle = () => setModal(!modal);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Confirm EOS Env. Change</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody> 
                <h5>Are you sure you want to change all users in {unit} to {selectedEnv} environment?</h5>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon type={'check'} onClick={updateUnitEnvironment} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;